import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { store, persistor } from "./Components/redux/store";
import "./index.css";
import App from "./App";
import { loadingGif } from "./assets/images";

// Video Loading Bileşeni
const Loading = () => (
  <div className="flex justify-center items-center h-screen">
    <video autoPlay loop muted className="w-[200px] h-[200px] md:w-[300px] md:h-[300px] object-cover">
      <source src={loadingGif} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
);

const Index = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Sayfa yüklenene kadar bekleme (örneğin 3 saniye)
    const timer = setTimeout(() => {
      setLoading(false); // 3 saniye sonra loading durumunu false yap
    }, 2000);

    return () => clearTimeout(timer); // Temizleme işlemi
  }, []);

  if (loading) {
    return <Loading />; // Sayfa yüklenene kadar loading video göster
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Index />);
